import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { sd } from '@sd/lib/sdPaths';
import { Header } from '@/components/layout/Header';
import { SupervisorSidebar } from '@/components/supervisor/SupervisorSidebar';
import { SupervisorDashboard } from '@/components/supervisor/SupervisorDashboard';
import { TeamWorkload } from '@/components/supervisor/TeamWorkload';
import { EscalationQueue } from '@/components/supervisor/EscalationQueue';
import { ApprovalWorkflows } from '@/components/supervisor/ApprovalWorkflows';
import { DepartmentView } from '@/components/supervisor/DepartmentView';

export default function Supervisor() {
  const { view = 'dashboard' } = useParams<{ view?: string }>();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleViewChange = (newView: string) => {
    navigate(sd(`supervisor/${newView}`));
  };

  const renderContent = () => {
    switch (view) {
      case 'dashboard':
        return <SupervisorDashboard />;
      case 'workload':
        return <TeamWorkload />;
      case 'escalations':
        return <EscalationQueue />;
      case 'approvals':
        return <ApprovalWorkflows />;
      case 'departments':
        return <DepartmentView />;
      default:
        return <SupervisorDashboard />;
    }
  };

  return (
    <div className="h-screen flex flex-col bg-background">
      <Header />
      <div className="flex-1 flex overflow-hidden">
        <SupervisorSidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
          activeView={view}
          onViewChange={handleViewChange}
        />
        {renderContent()}
      </div>
    </div>
  );
}
